export default __webpack_public_path__ + "static/media/pic-1.b105fe43.png";